<template>
    <NotificationComponent/>
    <div class="my-6 grid grid-cols-3">
        <div class="text-lg col-span-1">
            {{ period.name }}
        </div>
        <div class="text-lg col-span-1">
            {{ period.starts_at }}
        </div>
        <div class="text-lg col-span-1">
            {{ period.ends_at }}
        </div>
        <div class="tabs col-span-3 w-full flex justify-center">
            <div
                class="tab tab-lg tab-lifted"
                :class="{ 'tab-active text-sky-600': active === 'room' }"
                @click="setActive('room')"
            >
                Foglalható szobák
            </div>
            <div
                class="tab tab-lg tab-lifted"
                :class="{ 'tab-active text-sky-600': active === 'users' }"
                @click="setActive('users')"
            >
                Foglalásra jogosult kollégisták
            </div>
            <div
                class="tab tab-lg tab-lifted"
                :class="{ 'tab-active text-sky-600': active === 'reservations' }"
                @click="setActive('reservations')"
            >
                Foglalások
            </div>
            <div
                class="tab tab-lg tab-lifted"
                :class="{ 'tab-active text-sky-600': active === 'notifications' }"
                @click="setActive('notifications')"
            >
                Értesítések
            </div>
        </div>
        <div class="col-span-3">
            <AllowedRooms :period_id="period.id" v-show="active === 'room'" />
            <AllowedUsers :period_id="period.id" v-show="active === 'users'" />
            <Reservations :period_id="period.id" v-show="active === 'reservations'" />
            <Notifications :period_id="period.id" v-show="active === 'notifications'" />
        </div>
    </div>
</template>

<script>
import AllowedRooms from './AllowedRooms';
import AllowedUsers from './AllowedUsers';
import Reservations from './Reservations';
import Notifications from './Notifications';
import { isNull } from 'lodash';
import NotificationComponent from "../user/NotificationComponent";
import { SET_NOTIFICATION_TIMEOUT } from "../../store/constants/mutations";
import { mapMutations } from "vuex";

export default {
    name: 'Period',
    components: { NotificationComponent, AllowedRooms, AllowedUsers, Reservations, Notifications },
    props: {
        period: {
            required: true,
            type: Object,
        },
    },
    data () {
        return {
            active: 'reservations',
        };
    },
    methods: {
        ...mapMutations('Notification',[SET_NOTIFICATION_TIMEOUT]),
        setActive (val) {
            this.active = val;
            localStorage.setItem('period.active', val);
        },
    },
    mounted () {
        this.SET_NOTIFICATION_TIMEOUT(30 * 1000);
        if (!isNull(localStorage.getItem('period.active')))
            this.active = localStorage.getItem('period.active');
    },
};
</script>

<style scoped></style>
